/**
 *
 * dashboard service
 */

import { createAxiosServiceInstance, apiConfig } from '../api';
import { convertToUtcTime } from '../../util/index';
import { AMLS_TM_SAM } from '../../pages/constants/globalConstants';

const axios = createAxiosServiceInstance();
const tmChartsBaseUrl = `${apiConfig.serviceApi}${AMLS_TM_SAM}`;

const headers = {
  'Content-Type': 'application/json'
};

export async function getFigureData(payload) {
  const { from, to } = payload;
  const params = {
    to: convertToUtcTime(`${to} 23:59:59.999`),
    from: convertToUtcTime(`${from} 00:00:00.000`)
  };

  let url = `${tmChartsBaseUrl}/widget/topstat`;
  return await axios
    .get(url, { headers, params })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err.message;
    });
}

export async function getAlertYieldChartData(payload) {
  const { from, to } = payload;
  const params = {
    to: convertToUtcTime(`${to} 23:59:59.999`),
    from: convertToUtcTime(`${from} 00:00:00.000`)
  };

  let url = `${tmChartsBaseUrl}/widget/chart/alertsYield`;
  return await axios
    .get(url, { headers, params })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err.message;
    });
}

export async function getAlertsAnomaliesChartData(payload) {
  const { from, to } = payload;
  const params = {
    to: convertToUtcTime(`${to} 23:59:59.999`),
    from: convertToUtcTime(`${from} 00:00:00.000`)
  };

  let url = `${tmChartsBaseUrl}/widget/chart/anomaliesAlerts`;
  return await axios
    .get(url, { headers, params })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err.message;
    });
}

export async function getNoIssueL1ChartData(payload) {
  const { from, to } = payload;
  const params = {
    to: convertToUtcTime(`${to} 23:59:59.999`),
    from: convertToUtcTime(`${from} 00:00:00.000`)
  };

  let url = `${tmChartsBaseUrl}/widget/chart/noIssueL1`;
  return await axios
    .get(url, { headers, params })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err.message;
    });
}

export async function getStrChartData(payload) {
  const { from, to } = payload;
  const params = {
    to: convertToUtcTime(`${to} 23:59:59.999`),
    from: convertToUtcTime(`${from} 00:00:00.000`)
  };

  let url = `${tmChartsBaseUrl}/widget/chart/str`;
  return await axios
    .get(url, { headers, params })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err.message;
    });
}

export async function getCustomerViewData(payload) {
  const { from, to } = payload;
  const params = {
    ...payload,
    to: convertToUtcTime(`${to} 23:59:59.999`),
    from: convertToUtcTime(`${from} 00:00:00.000`)
  };

  let url = `${tmChartsBaseUrl}/widget/chart/alertedCustomers`;
  return await axios
    .get(url, { headers, params })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err.message;
    });
}

export async function getAlertStatusChartData(payload) {
  const { from, to } = payload;
  const params = {
    ...payload,
    to: convertToUtcTime(`${to} 23:59:59.999`),
    from: convertToUtcTime(`${from} 00:00:00.000`)
  };

  let url = `${tmChartsBaseUrl}/widget/chart/alertStatus`;
  return await axios
    .get(url, { headers, params })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err.message;
    });
}

export async function getCustomerClusterChartData(payload) {
  const { from, to } = payload;
  const params = {
    ...payload,
    to: convertToUtcTime(`${to} 23:59:59.999`),
    from: convertToUtcTime(`${from} 00:00:00.000`)
  };

  let url = `${tmChartsBaseUrl}/widget/chart/customerCluster`;

  return await axios
    .get(url, { headers, params })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err.message;
    });
}

export async function getChartData(payload) {
  const { from, to } = payload;
  const url = `/${namespace}/dashboards/riskView/globalChart?${
    from ? 'from=' + from : ''
  }${to ? '&to=' + to : ''}`;

  return await axios.get(url);
}

export async function getSegmentListData(payload) {
  let url = `${tmChartsBaseUrl}/customerSegments`;
  return await axios
    .get(url)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err.message;
    });
}

export async function getSegmentData(payload) {
  const { from, to } = payload;
  let url = `/${namespace}/dashboards/riskView/segmentsView?${
    from ? 'from=' + from : ''
  }${to ? '&to=' + to : ''}`;

  return await axios.get(url);
}

export async function getInSegmentData(payload) {
  const { segment, from, to } = payload;
  let url = `/${namespace}/dashboards/riskView/segmentsView/${segment}?${
    from ? 'from=' + from : ''
  }${to ? '&to=' + to : ''}`;

  return await axios.get(url);
}

export async function getCustomerData(payload) {
  const { from, to, segmentCode } = payload;
  const url = `/${namespace}/dashboards/riskView/customerSegmentView?${
    from ? 'from=' + from : ''
  }${to ? '&to=' + to : ''}&segmentCode=${segmentCode}`;

  return await axios.get(url);
}
